import React from "react";

export default function YearToYearMachinesSalesBarFilter({
  yearToYearFilter,
  handleChangePaymentType,
  machines,
  handleChangeInput = () => {},
  getData = () => {},
}) {
  return (
    <div className="rounded">
      <div className="row mt-3">
        <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-around">
          <div className="d-flex justify-content-center align-items-center justify-content-around mr-2">
            <div className="form-check mr-2 d-flex align-items-center">
              <input
                className="mr-2"
                type="radio"
                name="paymentTypeYearToYear"
                id="paymentTypeAllYearToYear"
                value=""
                checked={!yearToYearFilter.paymentType}
                onChange={handleChangePaymentType}
              />
              <label
                className="form-check-label"
                htmlFor="paymentTypeAllYearToYear"
              >
                Razem
              </label>
            </div>
            <div className="form-check mr-2 d-flex align-items-center">
              <input
                className="mr-2"
                type="radio"
                name="paymentTypeYearToYear"
                id="paymentTypeCardYearToYear"
                value="1"
                checked={yearToYearFilter.paymentType == "1"}
                onChange={handleChangePaymentType}
              />
              <label
                className="form-check-label"
                htmlFor="paymentTypeCardYearToYear"
              >
                Karta
              </label>
            </div>
            <div className="form-check mr-2 d-flex align-items-center">
              <input
                className="mr-2"
                type="radio"
                name="paymentTypeYearToYear"
                id="paymentTypeCashYearToYear"
                value="2"
                checked={yearToYearFilter.paymentType == "2"}
                onChange={handleChangePaymentType}
              />
              <label
                className="form-check-label"
                htmlFor="paymentTypeCashYearToYear"
              >
                Gotówka
              </label>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12 ">
          <div className="d-flex justify-content-lg-end justify-content-md-center h-100 align-items-center">
            {/* <div className="w-25"> */}
            <div className="input-group input-group-sm w-lg-50">
              <input
                className="form-control"
                placeholder="Automat"
                list="machines"
                name="machine"
                onChange={handleChangeInput}
                autoComplete="off"
                defaultValue={yearToYearFilter.machineName}
                onFocus={(e) => {
                  e.target.value = "";
                  handleChangeInput(e);
                }}
                onBlur={(e) => !e.target.value && getData()}
              />
              <datalist id="machines">
                {machines &&
                  machines.map((machine, idx) => (
                    <option
                      value={`${machine.Name} (${machine.SerialNo})`}
                      key={idx}
                    />
                  ))}
              </datalist>
              <button
                className="card btn-sm ml-2 fas fa-redo mr-2"
                style={{
                  backgroundColor: "#0140BE",
                  color: "white",
                  height: "2rem",
                }}
                onClick={getData}
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) 
}
